export default __webpack_public_path__ + "static/DSC_0420-5ce02815c5a4f8c92c5ef6d2f95513ce.jpg";